import { createSlice } from '@reduxjs/toolkit'

export const eyewearResultsSlice = createSlice({
  name: 'eyewearResults',
  initialState: {
    results: [],
    hasOpened: false,
    regionImage: null,
    countryImage: null,
  },
  reducers: {
    setResults: (state, action) => {
      state.results = action.payload
    },
    setHasOpened: (state, action) => {
      state.hasOpened = action.payload
    },
    setRegionImage: (state, action) => {
      state.regionImage = action.payload
    },
    setCountryImage: (state, action) => {
      state.countryImage = action.payload
    },
  },
})

export const { setResults, setHasOpened, setRegionImage, setCountryImage } = eyewearResultsSlice.actions

export default eyewearResultsSlice.reducer
